import React from "react"
import { UserInfo } from "../component/user/UserInfo"
import { UserFollowForm } from "../component/user/UserFollowForm"
import { TargetUserSettingForm } from "../component/user/TargetUserSettingForm"
import { useAccessContext } from "../component/guard/AccessGuard"
import { ViolationReportForm } from "../component/user/ViolationReportForm"
import { Paths } from "../paths"
import { usePathParams } from "popopo-lib-front/hook/path"
import { useUser, useUserSetting } from "popopo-lib-front/firestore-access"
import { firestore } from "../core"
import { UserId } from "popopo-msg"
import { SpinnerRow } from "../component/SpinnerRow"

export const User = () => {
  const context = useAccessContext()
  const { userId } = usePathParams(Paths.users.user)
  const user = useUser(firestore, userId)
  const currentUserId = UserId(context.credential.user.uid)
  const userSetting = useUserSetting(firestore, currentUserId, userId)

  if (user === "loading" || userSetting === "loading") {
    return <SpinnerRow />
  }

  if (user === null || user === undefined) {
    return (
      <div className="alert alert-warning my-4" role="alert">
        ユーザーが見つかりません
      </div>
    )
  }

  return (
    <div className="row">
      <h3>User Info</h3>
      <UserInfo user={user} />

      <h3>Follow User</h3>
      <UserFollowForm firebase={context.credential.user} userId={userId} />

      <h3>Violation Report</h3>
      <ViolationReportForm firebase={context.credential.user} userId={userId} />

      <h3>Target User Setting (対象ユーザーへの通知設定)</h3>
      <TargetUserSettingForm firebase={context.credential.user} targetUserId={userId} initialData={userSetting} />
    </div>
  )
}
